import { invoiceDateColumn } from './invoiceKanbanDates';
export type InvoiceBillingTone = 'month' | 'week' | 'today' | 'delayed' | 'complete' | 'canceled';
type BillingItem = { issue_date: string; invoice_status: string };
export function invoiceBillingTone(invoice: BillingItem, today = new Date()): InvoiceBillingTone {
  if (invoice.invoice_status === 'canceled') return 'canceled';
  if (invoice.invoice_status === 'complete') return 'complete';
  if (invoice.invoice_status === 'delayed') return 'delayed';
  const column=invoiceDateColumn(invoice.issue_date,today,undefined,false,invoice.invoice_status,true);
  return column==='today'?'today':column==='thisWeek'?'week':column==='delayed'?'delayed':'month';
}
export function invoiceGroupBillingTone(invoices: BillingItem[], today = new Date()): InvoiceBillingTone {
  const tones=new Set(invoices.map(invoice=>invoiceBillingTone(invoice,today)));
  return (['delayed','today','week','month','complete','canceled'] as const).find(tone=>tones.has(tone)) || 'month';
}
